/**
 * TODO: The definition of these colors here are TEMPORARY. They were
 * introduced in TS-15050 with the intention of being formalized in the theme
 * at some point with both light and dark variants. The temporary prefix is
 * intended.
 */
export const temporaryColors = {
  yellow: '#e2bb19',
  pink: '#f46791',
  orange: '#ff9800',
  green: '#9fd8b5',
  cyan: '#5cdae2',
  purple: '#b37dd8',
  blue: '#409cff',
} as const;
